import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import AddCodePopup from '../../Components/Popups/AddCodePopup';
import LearnerContentList from '../../Components/LearnerContentList';
import ThinkToolPopup from '../../Components/Popups/ThinkToolPopup';
import SaveEditPopup from '../../Components/Popups/SaveEditPopup';
import InviteDeclineReasonPopup from '../../Components/Popups/InviteDeclineReasonPopup';

import { commonStyles } from '../../styles/styles';
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn} from "mdbreact";

import ModulesCard from '../../Components/ModulesCard';
import ModulesCardReturn from '../../Components/Cards/ModulesCardReturn';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
const ContentView = ({ classes, view }) => (
  <div
    className={classes.mainBackground}
  >
   
   <ReactCSSTransitionGroup
          transitionName="slide"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>
<MDBContainer fluid>

    <MDBRow>
      {}
        <MDBCol className="pl-4" lg="3" md="4"><ModulesCardReturn/></MDBCol>
        <MDBCol lg="9" md="8" sm='12'><LearnerContentList/></MDBCol>
    </MDBRow>
    </MDBContainer>
    </ReactCSSTransitionGroup>
   
  </div>
);

const styles = () => ({
  ...commonStyles,
  userListColumn: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    maxWidth: 267,
    zIndex:1000,
  },
  toolsColumn: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    position: 'relative',
    flexDirection: 'column',
    left:-10,
    maxWidth: 230,
    zIndex:900,
  },
  dashboardColumn: {
    display: 'flex',
    flex: 5,
    paddingBottom:5
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    height:'100%',
    paddingBottom:10,
    alignItems: 'stretch',
    overflow: 'auto',
    backgroundColor: '#e8e8e8'
  }
});

export default compose(withStyles(styles))(ContentView);

ContentView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  view: PropTypes.instanceOf(Object),
};
